import React from "react";

function TrueFalseIcon({status}) {
    return (
        status  ?
            (<i className="far fa-check-circle fa-color-green"></i>)
            : (<i className="far fa-times-circle fa-color-red"></i>)
    )
}

export default TrueFalseIcon;
